import React, { useEffect, useState } from "react";
import splashIcon from "../../assets/img/icon-splash.png";
import "./splash.css";

function SplashScreen() {
  const [show, setShow] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setShow(false);
    }, 6000);
  });

  if (!show) return <></>;

  return (
    <div className="splash-screen">
      <div className="splash-screen-bg" />
      <div className="inner-wrapper">
        <div className="middle-section">
          <img src={splashIcon} alt="Splash Icon" />
        </div>
      </div>
    </div>
  );
}

export default SplashScreen;
